import type { Applicant } from '../types/applicant';

export const applicants: Applicant[] = [
  {
    id: 'hessa-al-falasi',
    name: 'Dr. Hessa Al Falasi',
    title: 'Space Systems Engineer',
    organization: 'Mohammed Bin Rashid Space Centre',
    location: 'Dubai',
    nationality: 'UAE',
    isEmirati: true,
    appliedOn: '2026-10-29',
    fields: ['Space Technology', 'Satellite Systems'],
    yearsExperience: 14,
    qualification: 'PhD Aerospace Engineering, MIT',
    qualificationScore: 29,
    referencesVerified: 3,
    referencesTotal: 3,
    fieldDemand: 'High',
    socialScore: 86,
    accounts: [
      { platform: 'LinkedIn', handle: 'hessa-alfalasi', followers: 38200 },
      { platform: 'X', handle: '@hessa_space', followers: 21400 },
    ],
    proposedDailyRate: 16000,
    motivation: 'I want to help translate the UAE’s space ambitions into public understanding and youth engagement.',
    highlights: ['Lead engineer on Emirates Mars Mission subsystems', '40+ public talks on space science', 'Mentor at UAE Space Agency youth programme'],
    status: 'New',
  },
  {
    id: 'daniel-okafor',
    name: 'Daniel Okafor',
    title: 'Supply Chain & Logistics Director',
    organization: 'DP World',
    location: 'Dubai',
    nationality: 'Nigeria',
    isEmirati: false,
    appliedOn: '2026-10-24',
    fields: ['Logistics', 'Trade Policy'],
    yearsExperience: 18,
    qualification: 'MBA, INSEAD',
    qualificationScore: 24,
    referencesVerified: 2,
    referencesTotal: 3,
    fieldDemand: 'Medium',
    socialScore: 68,
    accounts: [{ platform: 'LinkedIn', handle: 'danielokafor', followers: 22100 }],
    proposedDailyRate: 13000,
    motivation: 'Keen to share lessons on port digitalisation and resilient trade corridors with UAE entities.',
    highlights: ['Led digital twin rollout at Jebel Ali', 'Advisor to two African port authorities'],
    status: 'Interview',
  },
  {
    id: 'aisha-al-blooshi',
    name: 'Aisha Al Blooshi',
    title: 'Food Security Researcher',
    organization: 'UAE University',
    location: 'Al Ain',
    nationality: 'UAE',
    isEmirati: true,
    appliedOn: '2026-10-20',
    fields: ['Food Security', 'AgriTech'],
    yearsExperience: 8,
    qualification: 'MSc Agricultural Sciences, Wageningen',
    qualificationScore: 22,
    referencesVerified: 2,
    referencesTotal: 2,
    fieldDemand: 'High',
    socialScore: 61,
    accounts: [
      { platform: 'Instagram', handle: '@aisha.grows', followers: 14800 },
      { platform: 'LinkedIn', handle: 'aisha-alblooshi', followers: 4200 },
    ],
    proposedDailyRate: 8000,
    motivation: 'Passionate about vertical farming and the National Food Security Strategy 2051.',
    highlights: ['Published 6 papers on desert agriculture', 'Pilot lead for hydroponic farm in Al Ain'],
    status: 'Under review',
  },
  {
    id: 'lucas-ferreira',
    name: 'Lucas Ferreira',
    title: 'Urban Mobility Consultant',
    organization: 'Independent',
    location: 'Abu Dhabi',
    nationality: 'Brazil',
    isEmirati: false,
    appliedOn: '2026-10-11',
    fields: ['Smart Mobility', 'Urban Planning'],
    yearsExperience: 6,
    qualification: 'MSc Transport Planning, UCL',
    qualificationScore: 18,
    referencesVerified: 1,
    referencesTotal: 3,
    fieldDemand: 'Medium',
    socialScore: 44,
    accounts: [{ platform: 'LinkedIn', handle: 'lucasferreira-mobility', followers: 3100 }],
    proposedDailyRate: 9000,
    motivation: 'Looking to contribute to autonomous transport pilots across the UAE.',
    highlights: ['Contributed to two BRT feasibility studies'],
    status: 'Info requested',
  },
  {
    id: 'salem-al-dhaheri',
    name: 'Salem Al Dhaheri',
    title: 'Youth Entrepreneurship Coach',
    organization: 'Sheraa',
    location: 'Sharjah',
    nationality: 'UAE',
    isEmirati: true,
    appliedOn: '2026-10-05',
    fields: ['Entrepreneurship', 'Youth Development'],
    yearsExperience: 4,
    qualification: 'BSc Business, AUS',
    qualificationScore: 14,
    referencesVerified: 1,
    referencesTotal: 2,
    fieldDemand: 'Low',
    socialScore: 72,
    accounts: [
      { platform: 'Instagram', handle: '@salem.builds', followers: 29600 },
      { platform: 'X', handle: '@salemdhaheri', followers: 5400 },
    ],
    proposedDailyRate: 5000,
    motivation: 'I want to inspire young Emiratis to start and scale their own ventures.',
    highlights: ['Coached 60+ startups through accelerator programmes'],
    status: 'Under review',
  },
  {
    id: 'elena-markovic',
    name: 'Dr. Elena Markovic',
    title: 'Quantum Computing Researcher',
    organization: 'Technology Innovation Institute',
    location: 'Abu Dhabi',
    nationality: 'Serbia',
    isEmirati: false,
    appliedOn: '2026-09-28',
    fields: ['Quantum Computing', 'Artificial Intelligence Policy'],
    yearsExperience: 12,
    qualification: 'PhD Physics, ETH Zürich',
    qualificationScore: 28,
    referencesVerified: 3,
    referencesTotal: 3,
    fieldDemand: 'High',
    socialScore: 58,
    accounts: [
      { platform: 'LinkedIn', handle: 'elena-markovic-qc', followers: 9800 },
      { platform: 'YouTube', handle: '@QuantumWithElena', followers: 6200 },
    ],
    proposedDailyRate: 14000,
    motivation: 'Help government leaders prepare for the post-quantum era.',
    highlights: ['20+ peer-reviewed papers', 'Built TII’s quantum outreach programme'],
    status: 'Approved',
  },
];
